




















































import {Component, Vue} from 'vue-property-decorator'
import {Main, Container} from 'element-ui'
import {namespace} from 'vuex-class'

const layout = namespace('layout')

@Component({
  components: {
    [Container.name]: Container,
    [Main.name]: Main,
  },
})
export default class MainLayout extends Vue {
  @layout.Getter('errorSize') errorSize: number
  @layout.State('errors') errors: object[]

  visibleHeader: boolean = false
  visibleFooter: boolean = false

  get mainClasses(): object {
    return {
      'has-header': this.visibleHeader,
      'has-footer': this.visibleFooter,
      'has-error-s': this.errors.length === 1,
      'has-error-d': this.errors.length > 1
    }
  }

  mounted() {
    this.visibleHeader = Boolean(this.$slots.header)
    this.visibleFooter = Boolean(this.$slots.footer)
  }

  updated() {
    // TODO: refactor
    // this.$slots 가 업데이트 되어도 반응성이 없는 문제 해결 필요
    this.visibleHeader = Boolean(this.$slots.header)
    this.visibleFooter = Boolean(this.$slots.footer)
  }
}
